export default function getCookie(cname) {
  // Get a cookie value
  // Taken from https://www.w3schools.com/js/js_cookies.asp
  const name = `${cname}=`
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  // eslint-disable-next-line
  for (const i in ca) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      let start = name.length
      let end = c.length
      if (c.charAt(end - 1) === '"') {
        end -= 1
      }
      if (c.charAt(start) === '"') {
        start += 1
      }
      return c.substring(start, end)
    }
  }
  return ''
}



// WEBPACK FOOTER //
// ./utilities/cookie.js